import React from 'react';
import moment from 'moment';

interface Props {
    date?: string;
}

const FormattedDate: React.FC<Props> = ({ date }: Props) => {
    if (date === undefined) {
        return null;
    }

    if (!moment(date).isValid()) {
        return null;
    }

    return <div data-testid="date">{moment(date).format('DD-MM-YYYY')}</div>;
};

export default FormattedDate;
